import { styled } from '@thesisedu/web/dist'
import React from 'react'
import ReactPlayer from 'react-player'

export function Video({ node: { url } }) {
  return (
    <Container>
      <ReactPlayer url={url} controls width={'100%'} height={'100%'} className={'react-player'} />
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`
